export class UserPersonalDataModel {
  public userPersonalDataId: number;
  public userId: number;
  public birthDate?: string;
  public weight: number;
  public height: number;
  public genderTypeId?: number;
  public bloodTypeId?: number;
  public pregnancyTypeId?: number;
  public professionTypeId?: number;
  public notAllowedFoods: string;
  public allergies: string;
}